import { render, staticRenderFns } from "./CalendarTwoColumnList.vue?vue&type=template&id=5b1adf04&scoped=true"
import script from "./CalendarTwoColumnList.vue?vue&type=script&lang=js"
export * from "./CalendarTwoColumnList.vue?vue&type=script&lang=js"
import style0 from "./CalendarTwoColumnList.vue?vue&type=style&index=0&id=5b1adf04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1adf04",
  null
  
)

export default component.exports